import { parsePhoneNumber } from "libphonenumber-js";
import { Maybe } from "./util/maybe";
export var SmsDirection;
(function (SmsDirection) {
    SmsDirection["Inbound"] = "Inbound";
    SmsDirection["Outbound"] = "Outbound";
})(SmsDirection || (SmsDirection = {}));
export var SmsMessageStatus;
(function (SmsMessageStatus) {
    SmsMessageStatus["Unknown"] = "Unknown";
    SmsMessageStatus["Delivered"] = "Delivered";
    SmsMessageStatus["Failed"] = "Failed";
    SmsMessageStatus["Sent"] = "Sent";
    SmsMessageStatus["Received"] = "Received";
    SmsMessageStatus["Undelivered"] = "Undelivered";
    SmsMessageStatus["Accepted"] = "Accepted";
    SmsMessageStatus["Queued"] = "Queued";
    SmsMessageStatus["Scheduled"] = "Scheduled";
})(SmsMessageStatus || (SmsMessageStatus = {}));
const cleanPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) {
        return "";
    }
    const commasAsSemicolons = phoneNumber.replace(/,/g, ";");
    const parsed = parsePhoneNumber(commasAsSemicolons, "US");
    const cleaned = parsed.nationalNumber;
    const extension = parsed.ext;
    let prefix = "";
    if (cleaned[0] === "1" && cleaned.length >= 11) {
        prefix = "+";
    }
    else if (cleaned.length >= 10) {
        prefix = "+1";
    }
    const suffix = extension ? `x${extension}` : "";
    return `${prefix}${cleaned}${suffix}`;
};
export const toPhoneNumberE164 = (phoneNumber) => {
    if (!phoneNumber) {
        return "";
    }
    try {
        return cleanPhoneNumber(phoneNumber);
    }
    catch (e) {
        const onlyDigits = phoneNumber.replace(/\D/g, "");
        try {
            return cleanPhoneNumber(onlyDigits);
        }
        catch (e) {
            return onlyDigits;
        }
    }
};
export const isPhoneNumberE164 = (phoneNumber) => {
    if (!phoneNumber) {
        return false;
    }
    const potential = toPhoneNumberE164(phoneNumber);
    return potential.length === 12 && potential.startsWith("+1");
};
export const parseAreaCode = (raw) => {
    const cleaned = raw.replace(/\D/g, "");
    if (cleaned.length === 3) {
        return Maybe.fromValue(cleaned);
    }
    return Maybe.none();
};
export const hasAreaCode = (phoneNumber, areaCode) => {
    return phoneNumber.substring(2, 5) === areaCode;
};
export const SMS_MAX_LENGTH = 1600;
export const SMS_LENGTH_WARNING_THRESHOLD = 1500;
export var SmsConsentEventType;
(function (SmsConsentEventType) {
    SmsConsentEventType["SmsStart"] = "SmsStart";
    SmsConsentEventType["SmsStop"] = "SmsStop";
    SmsConsentEventType["PriorConsent"] = "PriorConsent";
    SmsConsentEventType["ImpliedConsent"] = "ImpliedConsent";
    SmsConsentEventType["WorkflowImpliedConsent"] = "WorkflowImpliedConsent";
    SmsConsentEventType["StopReminder"] = "StopReminder";
})(SmsConsentEventType || (SmsConsentEventType = {}));
export var SmsConsentStatus;
(function (SmsConsentStatus) {
    SmsConsentStatus["NewContact"] = "NewContact";
    SmsConsentStatus["None"] = "None";
    SmsConsentStatus["Implied"] = "Implied";
    SmsConsentStatus["Prior"] = "Prior";
    SmsConsentStatus["Subscribed"] = "Subscribed";
    SmsConsentStatus["Unsubscribed"] = "Unsubscribed";
})(SmsConsentStatus || (SmsConsentStatus = {}));
export var TelecomPhoneLineStatus;
(function (TelecomPhoneLineStatus) {
    TelecomPhoneLineStatus["Active"] = "Active";
    TelecomPhoneLineStatus["Provisioning"] = "Provisioning";
})(TelecomPhoneLineStatus || (TelecomPhoneLineStatus = {}));
export var TelecomPhoneLineCredentialType;
(function (TelecomPhoneLineCredentialType) {
    TelecomPhoneLineCredentialType["Global"] = "Global";
    TelecomPhoneLineCredentialType["Tenant"] = "Tenant";
})(TelecomPhoneLineCredentialType || (TelecomPhoneLineCredentialType = {}));
const EMERGENCY_NUMBERS = ["911", "988", "211", "311", "511", "811", "112", "999", "000"];
export const isEmergencyNumber = (phoneNumber) => {
    if (!phoneNumber) {
        return false;
    }
    const cleaned = phoneNumber.replace(/\D/g, "");
    return EMERGENCY_NUMBERS.includes(cleaned);
};
export const toSmsRecipient = (phoneNumber) => {
    if (!phoneNumber || isEmergencyNumber(phoneNumber)) {
        return Maybe.none();
    }
    return Maybe.some(phoneNumber);
};
//# sourceMappingURL=telecom.js.map